<template>
  <mdb-container class="gp-has-header">
    <mdb-card v-if="!executing && availablePlans.length ==0">
      <mdb-card-header>
        <h5>No Plans</h5>
      </mdb-card-header>
      <mdb-card-body>
        <p>There are currently no other plans to choose from.</p>
        <p>
          <mdb-btn v-if="loggedIn" icon="credit-card" @click="$router.push('/user/billing')">Back to Billing</mdb-btn>
          <mdb-btn v-if="!loggedIn" icon="home" @click="publicHome">Back to Home</mdb-btn>
        </p>
      </mdb-card-body>
    </mdb-card>

    <section v-if="availablePlans.length > 0 ">
      <div class="mb-4">
        <h2 class="h1-responsive font-weight-bold ">Available Plans</h2>
        <div class="text-right">
          <mdb-switch v-model="showYearly" offLabel="Monthly" onLabel="Yearly"/>
        </div>

        <gp-select v-if="!loggedIn && currencies.length > 0" :dataObj="currencyModel"
                   :possible-values="currencies" :required="false"
                   @valueChanged="newCurrency"
                   label="Currency" propertyName="selectedCurrency"/>

        <p v-if="settings.multiCurrency && loggedIn" class="grey-text small">
          Plans are shown in your currency when available. Your currency is determined by the country
          which you set on your
          <router-link to="/user/profile">user profile</router-link>
          (currently {{ userDetails.countryName }}).
        </p>
        <p v-if="limitByTier" class="warning-color small">
          Only plans that include the recent group you visited are shown. <mdb-btn size="sm" @click="limitByTier=false">Show all</mdb-btn>
        </p>
      </div>
      <div class="mb-4" v-if="introText" v-html="introText">

      </div>
      <mdb-row>
        <div v-for="plan in availablePlans"
             :key="plan.id" class="mb-4  col-lg-3 col-md-4 col-sm-12 d-flex align-self-stretch"
             v-if=" (!limitByTier || (limitByTier && plan.groupTierLevel >= minTier))  && ( (showYearly && plan.term=='Yearly') || (!showYearly && plan.term != 'Yearly')  )  ">
          <mdb-card pricing class="mb-2 w-100">
            <div :class="priceClass(plan)">
              <h2 class="gp-card-price">{{ plan.symbol }}{{ plan.price | formatNumber }} {{plan.currency}}</h2>
              <h5 v-if="!plan.isFreeTrialPlan">{{ plan.term }}</h5>
              <h5 v-if="plan.isFreeTrialPlan">&nbsp;</h5>
              <div class="version">
                <h5 class="mb-0">{{ plan.name }}
                  <mdb-badge color="warning" v-if="plan.currentPlan">Selected</mdb-badge></h5>
                <mdb-badge v-if="!plan.currentPlan && plan.price == 0 && !isMemberShipPlan && !isOwnershipPlan" color="success">For Most Users</mdb-badge>
              </div>
            </div>
            <mdb-card-body class="striped mb-1 grey-text small text-left">
              <div v-if="plan.marketingFeatures" v-html="plan.marketingFeatures"></div>
              <div v-if="!plan.marketingFeatures">

                <div v-for="tier in plan.includedTiers"><mdb-icon class="m-2" icon="check" color="success"/>Membership in {{tier}} groups. </div>
                <div v-if="plan.isOwnershipPlan"><mdb-icon class="m-2" icon="check" color="success"/>Includes group ownership. </div>
                <div v-if="plan.isOwnershipPlan"><mdb-icon class="m-2" icon="check" color="success"/>{{plan.maxGroups | formatInteger }} owned {{plan.maxGroups == 1 ? 'group' : 'groups'}} </div>
                <div v-if="plan.isOwnershipPlan"><mdb-icon class="m-2" icon="check" color="success"/>{{plan.maxMembers | formatInteger }} members across all owned groups. </div>
                <div v-if="!plan.isOwnershipPlan"><mdb-icon class="m-2" icon="times" color="danger"/>No group ownership. </div>
              </div>
            </mdb-card-body>
            <mdb-card-footer v-if="loggedIn" class="striped mb-1 grey-text small text-center">
              <mdb-btn :disabled="plan.currentPlan" @click="switchPlan(plan)">Select</mdb-btn>
            </mdb-card-footer>
          </mdb-card>
        </div>
      </mdb-row>
      <div class="mt-4">
        <mdb-btn v-if="loggedIn" icon="credit-card" @click="$router.push('/user/billing')">Back to Billing</mdb-btn>
        <mdb-btn v-if="!loggedIn" icon="home" @click="publicHome">Back to Home</mdb-btn>

      </div>

    </section>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import gpSelect from "../common/GPSelect";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbRow,
  mdbSwitch,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "shop-plans",
  display: "Shop Plans",
  order: 1,
  components: {
    mdbBadge,
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardFooter,
    mdbCardBody,
    mdbBtn,
    mdbRow,
    mdbCol,
    mdbIcon,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbSwitch,
    gpSelect
  },
  filters: {
    formatNumber: function (val) {
      return val.toLocaleString(undefined, {minimumFractionDigits: 2})
    },
    formatInteger: function (val) {
      return val.toLocaleString(undefined, {minimumFractionDigits: 0})
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    userDetails() {
      return this.$store.state.userDetails
    },
    executing() {
      return this.$store.state.executing
    },
    settings() {
      return this.$store.state.settings
    },
    backendUrl() {
      return process.env.BACKEND_URL
    }

  },
  watch: {
    userDetails: function (a, b) {
      if (a.id != b.id && !this.currencyModel.currencyCode) {
        this.currencyModel.selectedCurrency = this.userDetails.currencyCode
        this.loadDetails()
      }
    }
  },
  data() {
    return {
      availablePlans: [],
      introText: "",
      billingEligibleMemberships: 0,
      billingEligibleOwnerships: 0,
      showPricingModal: false,
      limitByTier: false,
      minTier: 0,
      showYearly: false,
      lastLoadedCurrency: "USD",
      currencyModel: {
        selectedCurrency: null
      },
      currencies: []
    }
  },
  mounted() {
    document.title = "Billing"
    if (this.$route.query.minTier) {
      this.minTier = parseInt(this.$route.query.minTier)
      this.limitByTier = true
    }
    if (this.loggedIn) {
      this.currencyModel.selectedCurrency = this.userDetails.currencyCode
    }
    this.loadDetails()
  },
  methods: {
    priceClass(plan) {
      let ret = "price header rounded-top text-white "
      if (plan.isOwnershipPlan) ret += "primary-color-dark"
      else ret += "primary-color"
      return ret
    },
    newCurrency(v) {
      console.log("New Currency is ", v, this.currencyModel)
      if (v != this.lastLoadedCurrency) {
        this.loadDetails()
        this.lastLoadedCurrency = v
      }
    },
    publicHome() {
      window.location.href = this.settings.staticSiteUrl
    },
    loadDetails() {
      this.$store.dispatch("setExecuting", true)
      let url =  "/user/availablePlans/"
      if (this.currencyModel.selectedCurrency) url += "?currency=" + this.currencyModel.selectedCurrency
      api.get(url).then(
        (results) => {
          this.availablePlans = results.data.plans
          if (this.availablePlans.length > 0) {
            if (this.availablePlans[0].currency !=this.currencyModel.selectedCurrency) {
              this.currencyModel.selectedCurrency = this.availablePlans[0].currency
            }
          }
          this.introText = results.data.introText
          if (!this.loggedIn) {
            if (!this.loggedIn) this.currencyModel.selectedCurrency = "USD"
            for (let currency of results.data.currencies) {
              let row = {text: currency.label, value: currency.code}
              this.currencies.push(row)
            }
          }
          this.billingEligibleMemberships = results.data.billingEligibleMemberships
          this.billingEligibleOwnerships = results.data.billingEligibleOwnerships

        },
        (error) => {
          if (error.response.status == 404) this.$router.push("/404")
          else this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    switchPlan(plan) {
      this.$store.dispatch("setExecuting", true)
      api.post("/user/switchPlan", {newPlan: plan.id}).then(
        (results) => {
          this.$router.push("/user/billing")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

};
</script>

<style lang='scss'>
.gp-card-price {
  padding: .75rem;
  font-size: 2rem;
  font-weight: 300;
}
</style>
